export default "__VITE_ASSET__C8L7z9OQ__"